module.exports = __webpack_public_path__ + "static/media/app-store-black.2967a3df.svg";